/**
 * useFirstName — returns the user's Telegram first_name with a localised
 * fallback when absent.
 *
 * Resolution chain (highest → lowest priority):
 *   1. AuthState.user.firstName (populated at boot from Telegram initData)
 *   2. useMe().data.firstName   (server-persisted; survives reloads)
 *   3. t('onboarding.greeting.fallback')  (localised default; key shipped by T016a)
 *
 * Per spec 016-onboarding-fidelity-fix FR-002 / SC-003: zero hardcoded
 * "Wanderer" / "Friend" strings — fallback must come through i18next.
 */

import { useTranslation } from 'react-i18next';
import { useAuth } from '../store/auth';
import { useMe } from './useMe';

export function useFirstName(): string {
  const storedFirstName = useAuth((s) => s.user?.firstName ?? null);
  const { data: me } = useMe();
  const { t } = useTranslation('flows');

  if (storedFirstName && storedFirstName.trim().length > 0) {
    return storedFirstName;
  }
  if (me?.firstName && me.firstName.trim().length > 0) {
    return me.firstName;
  }
  return t('onboarding.greeting.fallback', { defaultValue: 'friend' });
}
